module.exports = __webpack_public_path__ + "static/pic04-8cc4443521356fc2fc81f6b455f02a7d.jpg";